import * as React from 'react';
import styled from 'styled-components';
import { ClientPicker } from '../../common/components/ClientPicker';
import { HackyOnChangeClientEvent } from '../../common/custom-events/hacky-on-change-client.event';
import { useLeftNavigation } from './hooks';
import { LeftNavigationLeftDrawer, LeftNavigationLeftDrawerProps } from './LeftNavigation/LeftNavigationLeftDrawer';
import { LeftNavigationTopBar } from './LeftNavigation/LeftNavigationTopBar';

const DEFAULT_LOGO_SRC = '../../../img/DS_Horizontal Logo_RGB.svg';

const StyledContextPicker = styled.div`
    flex: auto;
    padding-left: 8px;
    padding-right: 8px;
`;

export function LeftNavigationContainer({
    topOffsetBanner,
}: Pick<LeftNavigationLeftDrawerProps, 'topOffsetBanner'>): JSX.Element {
    const {
        currentUrlPath,
        currentView,
        homeHref,
        isDrawerOpen,
        isLoadingDrawerPreference,
        logoImageSrc: userLogoImageSrc,
        logoLoading,
        navigation,
        notifications,
        onClickDismissAllNotifications,
        onClickDismissNotification,
        onDrawerToggle,
        onToggleView,
        profileNavigation,
        userInfo,
    } = useLeftNavigation();

    const logoImageSrc = userLogoImageSrc ?? DEFAULT_LOGO_SRC;

    // Show client picker for template categories routes
    const contextPicker = currentUrlPath.includes('/template-categories') ? (
        <StyledContextPicker>
            <ClientPicker
                onChange={newClientId => {
                    /*
                     * This is hacky because of the angular/left nav design
                     * DO NOT repeat this unless you absolutely need to
                     */
                    HackyOnChangeClientEvent.publish(new HackyOnChangeClientEvent(newClientId));
                }}
            />
        </StyledContextPicker>
    ) : null;

    return (
        <>
            <LeftNavigationTopBar
                contextPicker={contextPicker}
                currentView={currentView}
                helpUrl="/trythis"
                homeHref={homeHref}
                isOpenDrawer={isDrawerOpen}
                logoImageSrc={logoImageSrc}
                logoLoading={logoLoading}
                notifications={notifications}
                profileNavigation={profileNavigation}
                topOffsetBanner={topOffsetBanner}
                userInfo={userInfo}
                onClickDismissAllNotifications={onClickDismissAllNotifications}
                onClickDismissNotification={onClickDismissNotification}
                onClickHamburger={onDrawerToggle}
                onToggleView={onToggleView}
            />
            {!isLoadingDrawerPreference && (
                <LeftNavigationLeftDrawer
                    currentView={currentView}
                    isOpenDrawer={isDrawerOpen}
                    navigation={navigation}
                    topOffsetBanner={topOffsetBanner}
                    onClickMore={onDrawerToggle}
                    onToggleView={onToggleView}
                />
            )}
        </>
    );
}

LeftNavigationContainer.displayName = 'LeftNavigationContainer';
